'use strict';

import * as Colors from './Colors.js';
import {is_object, is_string} from "../Helpers/js";

export class Logger {

    constructor(...prefixes) {
        this.muted = false;
        this.prefix(...prefixes);
    }

    prefix(...prefixes) {
        this._prefix = prefixes;

        // start with grey text after prefix
        this._prefix.push(Colors.grey);
    }

    mute() {
        this.muted = true;
    }

    unmute() {
        this.muted = false;
    }

    log(...messages) {
        if (this.muted) {
            return;
        }

        messages = this._prefix ? [...this._prefix, ...messages] : messages;

        let objs = messages.filter(item => is_object(item)),
            msgs = messages.filter(item => is_string(item)),
            vars = messages.filter(item => !is_object(item) && !is_string(item)),
            structure = msgs.map(msg => msg.startsWith('css') ? '%c' : '%s ');

        // eslint-disable-next-line no-console
        console.groupCollapsed(structure.join(''), ...msgs, ...vars);
        // eslint-disable-next-line no-console
        console.log(...objs);
        // eslint-disable-next-line no-console
        console.trace();
        // eslint-disable-next-line no-console
        console.groupEnd();
    }
}